function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "no_folder"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m20 6h-7.278l-.457-1.376c-.32-.926-1.293-1.624-2.265-1.624h-1c-.552 0-1 .447-1 1s.448 1 1 1h1c.12 0 .333.157.371.265l.68 2.05c.136.409.518.685.949.685h8v8c0 .553.448 1 1 1s1-.447 1-1v-8c0-1.103-.897-2-2-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m3.707 2.293c-.391-.391-1.023-.391-1.414 0s-.391 1.023 0 1.414l1.707 1.707v.586c-1.103 0-2 .897-2 2v11c0 1.103.897 2 2 2h15.586l.707.707c.195.195.451.293.707.293s.512-.098.707-.293c.391-.391.391-1.023 0-1.414zm.293 16.707v-11h2.586l11 11z"
})));

var Svg072Folder = function Svg072Folder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg072Folder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/072-folder.fe258f6b.svg";
export { ForwardRef as ReactComponent };